import { formatBalanceNumber } from "../../communication/format";
import { useState } from "react";
import { ExplytStorePurchasePopup } from "./ExplytStorePurchase";
import { Popup } from "../Common/Elements/Popup";

export type ExplytStoreItem = {
    id: string,
    imageElement: JSX.Element,
    name: string,
    price: number,
    currency: "Credits"
    description: string
}

export function ExplytStoreItemEntry({ item }: { item: ExplytStoreItem }) {
    const [purchasePageEnabled, setPurchasePageEnabled] = useState(false);

    const purchasePopup = <Popup
        contentFactory={d => <ExplytStorePurchasePopup {...d} />}
        isOpen={purchasePageEnabled}
        setIsOpen={setPurchasePageEnabled}
        data={{ item: item, balance: 100 }}
        zIndex={10}
    />

    return <div
        className="small-margin flex-row small-gap flex-y-center"
        style={{ width: "calc(100% - 2rem)", cursor: "pointer" }}
        onClick={() => setPurchasePageEnabled(true)}
    >
        <div style={{ width: "3rem", height: "3rem" }}>
            {item.imageElement}
        </div>
        <span className="font-white medium-font"> {item.name} </span>
        <div className="flex-row flex-right tiny-gap" style={{ marginLeft: "auto" }}>
            <span className="font-white medium-font"> {formatBalanceNumber(item.price)} </span>
            <span className="font-gray medium-font"> {item.currency} </span>
        </div>
        {purchasePopup}
    </div>
}